import { Component, OnInit, Input, ContentChildren, QueryList, ChangeDetectorRef, ViewContainerRef } from '@angular/core';
import { HasCardComponent } from '../../interfaces/hasCardComponent';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'ndms-card-form',
  templateUrl: './ndms-card-form.component.html',
  styleUrls: ['./ndms-card-form.component.scss']
})
export class NdmsCardFormComponent implements OnInit {

  @Input() label: string;
  @Input() colSize: number = 3;
  @ContentChildren(HasCardComponent) formControls: QueryList<HasCardComponent>;

  public abstractControlArrays: HasCardComponent[][] = [];
  
  constructor(private _cdr: ChangeDetectorRef) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.abstractControlArrays = this.calculateArrayControls();
    console.log('acas', this.abstractControlArrays);
    this._cdr.detectChanges();
  }

  calculateArrayControls() {
    let acas: HasCardComponent[][] = [];
    let arrayControls = this.formControls.toArray().slice();

    while (arrayControls.length > 0) {
      acas.push(arrayControls.splice(0, this.colSize));
    }

    return acas;
  }

  getArrayControls() {
    return this.abstractControlArrays;
  }

  private getSingleItemClass() {
    return 'col-md-' + (12 / this.colSize);
  }

}
